<script setup>
import DateRangeFilter from '@/components/Form/DateRangeFilter.vue';
import SportBettingFinance from './Partials/SportBettingFinance.vue';
import CasinoFinance from './Partials/CasinoFinance.vue';
import LiveCasinoFinance from './Partials/LiveCasinoFinance.vue';
import NewCasinoFinance from './Partials/NewCasinoFinance.vue';
import { modelDateValue } from '@/helpers';
import { ref } from 'vue';

const filters = ref({
  sd: modelDateValue(),
  ed: modelDateValue()
});

const applyFilters = (dates) => {
  filters.value = { ...dates };
};
</script>

<template>
  <div>
    <DateRangeFilter @apply="applyFilters" />

    <div class="mt-4 px-4 space-y-4">
      <div>
        <h3 class="text-sm font-bold text-white/60 mb-2">{{ $t('app.5') }}</h3>
        <div class="fin-Container">
          <table class="fin-Table">
            <SportBettingFinance
              :start-date="filters.sd"
              :end-date="filters.ed"
            />
          </table>
        </div>
      </div>

      <div>
        <h3 class="text-sm font-bold text-white/60 mb-2">{{ $t('app.34') }}</h3>
        <div class="fin-Container">
          <table class="fin-Table">
            <NewCasinoFinance
              :start-date="filters.sd"
              :end-date="filters.ed"
            />
          </table>
        </div>
      </div>

      <div>
        <h3 class="text-sm font-bold text-white/60 mb-2">{{ $t('app.7') }}</h3>
        <div class="fin-Container">
          <table class="fin-Table">
            <LiveCasinoFinance
              :start-date="filters.sd"
              :end-date="filters.ed"
            />
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.fin-Container {
  background-image: var(--mgc-bg);
  @apply rounded-md overflow-hidden;
}

.fin-Table {
  @apply w-full text-neutral-200 divide-y divide-neutral-500/30;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
}

@media (max-width: 640px) {
  .fin-Table {
    font-size: 2.5vw;
    line-height: 7vw;
  }
}

.fin-Table th,
.fin-Table td {
  @apply px-2;
}

.fin-Table th {
  @apply font-normal text-neutral-400;
}

.fin-Table .left {
  @apply text-left;
}
</style>
